export const header = {
  headerTitle: 'My Profile',
  headerDescription: '',
  headerAction1: {
    id: 'createProfile',
    label: 'Create Profile',
    icon: 'PlusIcon',
  },
};
